import { useState, useEffect } from 'react';

/**
 * Hook pour persister un état dans localStorage
 * @param {string} key - Clé localStorage
 * @param {any} initialValue - Valeur par défaut
 * @returns {[any, function]} - [valeur, setValue]
 */
export function useLocalStorage(key, initialValue) {
  // Récupérer la valeur initiale depuis localStorage
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const item = localStorage.getItem(key);
      if (item === null) return initialValue;

      // Gérer les booléens stockés comme strings
      if (item === 'true') return true;
      if (item === 'false') return false;

      // Essayer de parser en JSON, sinon retourner la string
      try {
        return JSON.parse(item);
      } catch {
        return item;
      }
    } catch (error) {
      console.warn(`Erreur lecture localStorage "${key}":`, error);
      return initialValue;
    }
  });

  // Mettre à jour localStorage quand la valeur change
  useEffect(() => {
    try {
      if (storedValue === undefined) {
        localStorage.removeItem(key);
      } else if (typeof storedValue === 'boolean' || typeof storedValue === 'string') {
        localStorage.setItem(key, String(storedValue));
      } else {
        localStorage.setItem(key, JSON.stringify(storedValue));
      }
    } catch (error) {
      console.warn(`Erreur écriture localStorage "${key}":`, error);
    }
  }, [key, storedValue]);

  return [storedValue, setStoredValue];
}

export default useLocalStorage;
